module.exports = "<!-- This is an abstract template and should not be used directly-->\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.html
// module id = ../../../../../src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.html
// module chunks = main